/**
 * @desc 邮件帐号列表
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(params: API.crm.mailAccount.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/crm/mailAccount/page/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
